import React from 'react';
import ProjectDetails from './ProjectDetails';
import { projects } from '../../Data/Projects';

const Projects = () => {

    return (
        <div className='md:px-20 container mx-auto py-20'>
           <h1 className='text-2xl lg:text-5xl text-center font-bold'>⚙️🔧 My Projects 🔨⚙️</h1>
            <div>
                {
                    projects?.map(project => <ProjectDetails project={project} key={project.id} ></ProjectDetails>)
                }
            </div>
        </div>
    );
};

export default Projects;